import adminAxios from './adminAxiosInstance';

let interceptorAttached = false;

export const setupAdminAxiosInterceptor = (navigate) => {
    if (interceptorAttached) return;

    adminAxios.interceptors.response.use(
        response => response,
        error => {
            const status         = error.response?.status;
            const backendMessage = error.response?.data?.message || 'Неизвестная ошибка';
            const time           = error.response?.data?.timestamp;

            if (status === 500) {
                navigate('/error', {
                    state: { code: 500, backendMessage, time },
                });
            }

            return Promise.reject(error);
        }
    );

    interceptorAttached = true;
};
